// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component, PropTypes, Translate } from '@plesk/ui-library';

class Progress extends Component {
    componentDidMount() {
        Jsw.Observer.append(task => {
            if (task.id === this.props.task.id) {
                Jsw.redirect('/');
            }
        }, 'plesk:taskComplete');

        window.addEventListener('error', () => Jsw.redirect('/'));
    }

    render() {
        return (
            <div className="text-center">
                <h4>
                    <Translate content="setupProgress" />
                </h4>
                <div className="progress progress-xs" style={{ margin: '20px -20px -20px' }}>
                    <div className="progress-bar progress-bar-success progress-bar-striped active" style={{ width: '100%' }} />
                </div>
            </div>
        );
    }
}

Progress.propTypes = {
    task: PropTypes.object.isRequired,
};

export default Progress;



// WEBPACK FOOTER //
// ./views/admin/setup/progress.js